














































import { Component, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import repository from '@/modules/machinery/services/machineryProfilesRepository';
import cPopup from '@/components/default/Popup.vue';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
  components: {
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class MachineryProfilesPage extends Vue {
  private items: IMachineryProfileListItem[] = [];
  private loading: boolean = false;
  private saving: boolean = false;
  private displayAddProfileDialog: boolean = false;
  private addProfileDtu: any = { name: '' };

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    try {
      this.loading = true;
      this.items = (await repository.getAll()).data;
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  private selectRow(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
      this.$router.push({ path: `/settings/machineryprofiles/${e.data.id}` });
    }
  }

  private async add() {
    try {
      const validationResult = (this.$refs.addMachineryProfileForm as any).instance.validate();
      if (validationResult.isValid) {
        this.saving = true;
        const result = (await repository.create(this.addProfileDtu.name));
        notificationService.saved();
        this.$router.push({ path: `/settings/machineryprofiles/${result.data.id}` });
        this.$emit('saved');
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        self.saving = true;
        await repository.delete(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch {
        notificationService.failedToSave();
      } finally {
        self.saving = false;
      }
      resolve(true);
    });
  }

  get columns() {
    return [
      {
        dataField: 'id',
        caption: this.$t('objects.MachineryProfiles.fields.Id'),
      },
      {
        dataField: 'name',
        caption: this.$t('objects.MachineryProfiles.fields.Name'),
      },
      {
        type: 'buttons',
        buttons: ['delete'],
      },
    ];
  }
}
